<template>
    <div id="microsoftsource" v-on:keyup.esc="$root.$emit('CLOSESOURCEDIALOG')" class="dialog draggable-item bg-light light w-100-sm w-100-md w-75-lg  w-50-xl h-75">

        <DialogTitle :title="$t('Configure Backup Source')" :defaultTitle="$t('Configure Backup Source')" :subTitle="source.type_name" @closeDialog="$root.$emit('CLOSESOURCEDIALOG')" />

        <!--SCELTA DEL SERVICE ACCOUNT + SCELTA PERCORSI-->

        <div v-if="step == STEP_SA_AND_SOURCE" class="dialog-content d-flex flex-column overflow">
            <!------------------------------SCELTA DEL SERVICE ACCOUNT--------------------------------------------------------------->
            <!--Questa pagina deve implementare il metodo "sendSATestResult"-->
            <!--type = -1 : il componente visualizzerà la lista passata-->
            <SARepoSelect :type="$root.getMicrosoftTypes()" :idSA=source.id_service_account :idRepo="-2" @sendSATestResult="sendSATestResult" />

            <SelectedResourcesLayout :buttonText="buttonText" :singleItem="false" :isDisabled="!testResult.ok" :list="source.folderSource.paths" :heightPercentage="40" :canCancel="true" :type="source.type" @clickFunction="toggleFileSystemSidebar" class="flex-grow" />

        </div>

        <!--FILTRI-->
        <div v-if="step == STEP_FILTERS" class="dialog-content">
            <BackupSteps :extensionsFilter="true" :fileSizeFilter="true" :exclusions="false" @sendOptions="(options) => source.options = options" :options="source.options" key="filters" />
        </div>


        <!--BACKUP-->
        <div v-show="step == STEP_BACKUP" class="dialog-content">
            <div class="form-group">
                <h6 class="text-bold">
                    <span>{{ $t('Backup mode') }}</span>
                </h6>
            </div>
            <div class="form-group row">
                <label>{{ $t("Type") }}:</label>
                <select v-model="source.options.backupType" data-role="select" class="input mb-6" data-filter="false">
                    <option v-for="key in Object.keys($root.selectValues.backupTypes)" :value="key" v-bind:key="key">{{
                        $t($root.selectValues.backupTypes[key]) }}</option>
                </select>
            </div>

            <div class="form-group row d-flex flex-justify-between">
                <label>{{ $t("Number of copies") }}:</label>
                <input type="number" v-range="{ min: 1, max: 365 }" v-number v-model.number="source.options.nCopies" data-role="input" />
            </div>

            <div class="form-group row d-flex flex-justify-between">
                <label>{{ $t("Number of parallel threads") }}:</label>
                <input type="number" v-range="{ min: 1, max: 10 }" v-number v-model.number="source.options.nThreads" data-role="input" />
            </div>
        </div>
        <!--COMPRESSIONE ZIP-->
        <div class="dialog-content p-4" v-if="step == STEP_COMPRESSION" :disabled="source.options.backupType == 'U'">
            <BackupSteps :zipCompression="true" key="zipCompression" @sendOptions="(options) => source.options = options" :options="source.options" />
        </div>
        <div class="dialog-actions">
            <ClientMessageView ref="FMV_MS" :commands="['GetMicrosoft365List']" />
            <button v-on:click="setStep(step - 1)" class="button secondary" :disabled="step == 0"><span class="mif-arrow-left mr-2"> </span>{{ $t('Back') }}</button>
            <button v-on:click="setStep(step + 1)" class="button secondary" :disabled="!enableNextButton" v-disable-tooltip:nextButtonDisabled_message>{{ $t('Next') }} <span class="mif-arrow-right ml-2"> </span></button>
            <button v-on:click="saveSource" :disabled="!enableSaveButton" class="button secondary">{{ $t('Save') }}</button>
            <button class="button float-right ml-2" @click="$root.$emit('CLOSESOURCEDIALOG')">{{ $t("Close") }}</button>
        </div>
    </div>
</template>
<script>
import DialogTitle from "../../utils/DialogTitle";
//import NoDataAvailable from "../../utils/NoDataAvailable.vue";
import SARepoSelect from "../../utils/SARepoSelect.vue";
import SelectedResourcesLayout from "../../utils/SelectedResourcesLayout.vue";
import { isValid, waitSeconds } from "../../../utils/utilitiesmodule";
import { FileSystemSidebarConfig } from "../../../models/TreeNode";
import { draggableMixin } from "../../../mixins/draggable-mixin";
import BackupSteps from "../../utils/BackupSteps.vue";
import ClientMessageView from "../view/ClientMessageView.vue";
import { ClientMessage } from "../../../utils/objects";

export default {
    name: "MicrosoftSource",
    mixins: [draggableMixin],
    props: {
        source: Object,
    },
    components: {
        "DialogTitle": DialogTitle,
        //"NoDataAvailable": NoDataAvailable,
        "SARepoSelect": SARepoSelect,
        SelectedResourcesLayout,
        BackupSteps,
        ClientMessageView
    },
    created: async function () {

        this.buttonText = this.source.type == this.$ONEServiceType.Microsoft_OneDriveForBusiness
            ? 'Select the accounts to be backed up'
            : this.source.type == this.$ONEServiceType.Microsoft_SharePoint
                ? 'Select the sites to be backed up'
                : this.source.type == this.$ONEServiceType.Microsoft_Teams
                    ? 'Select the teams and channels to be backed up'
                    : "";

        this.$root.$on("endListingFromFileSystemSidebar", () => {
            if (this.source.folderSource.paths == 0) {
                this.setClientMessage(ClientMessage.info_translated(this.$t("Select at least one item to include in the backup")));
                return;
            }
        });

    },
    beforeDestroy() {
        this.$root.$off("endListingFromFileSystemSidebar");
    },
    data() {
        return {
            step: 0,
            testResult: {
                ok: false,
                okNumber: 0,
                serviceAccount: { id: -2, type: this.source.type },
                client: null,// il client della piattaforma che effettuerà le richieste dei list
                list: null,
            },

            buttonText: null,

            STEP_SA_AND_SOURCE: 0,
            STEP_FILTERS: 1,
            STEP_BACKUP: 2,
            STEP_COMPRESSION: 3,

        }
    },
    computed: {
        nextButtonState() {
            var clientMessage = null;

            switch (this.step) {
                case this.STEP_SA_AND_SOURCE: {
                    if (!this.testResult.serviceAccount || this.testResult.serviceAccount == -2 || !this.testResult.ok) {
                        clientMessage = ClientMessage.info_translated(this.$t("Select and validate a service account"));
                        this.setClientMessage(clientMessage);
                        return {
                            buttonTitle: clientMessage.text,
                            isEnabled: false
                        };
                    }

                    if (this.testResult.ok && this.source.folderSource.paths.length == 0) {
                        clientMessage = ClientMessage.info_translated(this.$t('Select at least one item to include in the backup'));
                        this.setClientMessage(clientMessage);
                        return {
                            buttonTitle: clientMessage.text,
                            isEnabled: false
                        };
                    }

                    break;

                }

                case this.STEP_BACKUP: {
                    if (this.source.options.backupType == 'U') {
                        return {
                            buttonTitle: "",//clientMessage.text,
                            isEnabled: false
                        };
                    }

                    break;
                }

                case this.STEP_COMPRESSION: {
                    return {
                        buttonTitle: "",
                        isEnabled: false
                    };
                }
            }

            this.setClientMessage(null);
            return {
                buttonTitle: "",
                isEnabled: true
            };

        },
        enableNextButton() {
            return this.nextButtonState.isEnabled;
        },
        nextButtonDisabled_message() {
            return this.nextButtonState.buttonTitle;
        },
        enableSaveButton() {
            return this.step == this.STEP_COMPRESSION || (this.STEP_BACKUP && this.source.options.backupType == 'U')
        }
    },
    methods: {
        async sendSATestResult(testResult) {
            this.testResult = testResult;
        },

        setStep(nStep) {
            this.step = nStep;

            this.$root.$emit("closeFileSystemSidebar");
        },

        toggleFileSystemSidebar() {
            let limit = this.$session.getLicenses().backup.find(l => l.nome_licenza == "Microsoft 365").total_slots;

            var config = FileSystemSidebarConfig.get(
                this.source.type,
                false,
                limit,
                this.testResult.client,
                null,//rootpath
                null,//tree
                false
            );

            this.$root.$emit(
                "toggleFileSystemSidebar",
                this.source.folderSource.paths,
                config
            );
        },

        saveSource() {
            if (this.source.folderSource.paths[0].nodeID == "node") {
                this.source.folderSource.paths[0].path = "";
                /*var litePaths=[];
                this.source.folderSource.paths.forEach(node => {
                    litePaths.push(node.buildLiteTree());
                });*/
            }


            if (isValid(this.testResult)) {
                this.source.id_service_account = this.testResult.serviceAccount.id;
            }
            //var newSource = source;
            //newSource.folderSource.paths = litePaths;
            this.$root.$emit("saveBackupSource", this.source);
        },

        setClientMessage(message) {
            if (this.$refs.FMV_MS) {
                this.$refs.FMV_MS?.setClientMessage(message);
            } else {
                waitSeconds(0.5).then(() => {
                    this.$refs.FMV_MS?.setClientMessage(message);
                });
            }
        }


    }
}
</script>
